<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Details</h2>
      <p class="step-text">
        Geben Sie die Eckpunkte der Wohnung an. Mehrfachnennungen sind möglich.
      </p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <SelectBox
          class="box-item small-icon-w-50"
          text="Lift"
          v-model="fields.flagLift.value"
          :iconDefault="require('@/assets/icons/Svgs/Vereinigungsmenge_73.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Vereinigungsmenge_73_white.svg')
          "
        />
        <SelectBox
          class="box-item small-icon-w-50"
          text="Balkon, Terrasse,<br/>Loggia"
          v-model="fields.flagBalkon.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7903.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7903_white.svg')"
        />
        <SelectBox
          class="box-item small-icon-w-80"
          text="Garage/<br/>Tiefgarage"
          v-model="fields.flagGarage.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7987.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7987_white.svg')"
        />
        <SelectBox
          class="box-item small-icon-w-50"
          text="Keller"
          v-model="fields.flagKeller.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7900.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7900_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectBox from "@/components/shared/SelectBox.vue";
import { getFromStorage, saveToStorage, isSet } from "@/utils.js";
export default {
  name: "dg-wohnung-step-7a",
  components: {
    SelectBox,
  },
  data() {
    return {
      fields: {
        flagLift: { value: "false" },
        flagBalkon: { value: "false" },
        flagGarage: { value: "false" },
        flagKeller: { value: "false" },
        whgBalkonM2: { value: null },
        whgGaragenStk: { value: null },
        whgKellerM2: { value: null },
      },
    };
  },
  methods: {
    isSet: isSet,
    goBack() {
      saveToStorage(this.fields);
      this.$router.push("/dg-wohnung-step-6");
    },
    goNext() {
      if (!isSet(this.fields.flagBalkon.value)) {
        this.fields.whgBalkonM2.value = null;
      }
      if (!isSet(this.fields.flagGarage.value)) {
        this.fields.whgGaragenStk.value = null;
      }
      if (!isSet(this.fields.flagKeller.value)) {
        this.fields.whgKellerM2.value = null;
      }
      saveToStorage(this.fields);
      if (
        isSet(this.fields.flagBalkon.value) ||
        isSet(this.fields.flagGarage.value) ||
        isSet(this.fields.flagKeller.value)
      ) {
        this.$router.push("/dg-wohnung-step-7b");
      } else {
        this.$router.push("/dg-wohnung-step-8");
      }
    },
  },
  mounted() {
    this.$emit("setStep", "dg-wohnung", 8);
    getFromStorage(this.fields);
  },
};
</script>
<style scoped>
.box-item {
  flex-basis: 320px;
}
</style>
